import { mapMaritalStatusToTraditionalLTC } from '@shared';
import type { BuyerOption } from '@/features/shop-insurance';

export { mapMaritalStatusToTraditionalLTC, isClientMarriedOrPartnered } from '@shared';

export const getMaritalClassForTraditionalLTC = (
  paymentOption: string,
  selectedBuyerOption: BuyerOption,
  hasPartnerWithDemographics: boolean,
  clientMaritalStatus?: string,
): string => {
  const mappedMaritalStatus = mapMaritalStatusToTraditionalLTC(clientMaritalStatus);
  if (['Monthly', 'Annually'].includes(paymentOption)) {
    if (mappedMaritalStatus === 'Married' || hasPartnerWithDemographics) {
      return selectedBuyerOption.maritalClass;
    } else {
      return 'Single';
    }
  } else {
    return mappedMaritalStatus;
  }
};
